import PersonaScreen from "./PersonaScreen";

/** Consumer (ticket holder) view — placeholder per ADR 0007. */
export default function ConsumerScreen({ onLogout }: { onLogout: () => void }) {
  return (
    <PersonaScreen title="Legends · Consumer" copy="Your tickets live here." onLogout={onLogout} />
  );
}
